export default [

     {
          path: '/control-type',
          name: 'ControlType',
          component: () => import("@/views/Page/ControlType/ControlType.vue"),
           meta: {
               title: '#Default# | ControlType',
          },
     }
];